import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ClosedownService } from '@app/services/closedown/closedown.service';
import { JobService } from '@app/services/job/job.service';
import { NavigationService } from '@app/services/navigation/navigation.service';

@Component({
  selector: 'app-resource-admin-dashboard',
  templateUrl: './resource-admin-dashboard.component.html',
  styleUrls: ['./resource-admin-dashboard.component.scss'],
  standalone: false
})
export class ResourceAdminDashboardComponent implements OnInit {
  isRedirectingToWorkbench = false;
  readonly dashboardCounts = {
    openJobs: 0,
    pendingApprovalJobs: 0,
    openPpms: 0,
    jobsAwaitingInvoice: 6,
    pendingInvoiceApproval: 4,
    recalledInvoices: 12,
    rejectedInvoices: 1
  };

  constructor(
    private readonly closedownService: ClosedownService,
    private readonly jobService: JobService,
    private readonly navigationService: NavigationService,
    private readonly router: Router
  ) {
    this.navigationService.onChange(true, false);
  }

  ngOnInit(): void {
    this.jobService.getDashboardSummary().subscribe({
      next: summary => {
        this.dashboardCounts.openJobs = summary.openJobs;
        this.dashboardCounts.pendingApprovalJobs = summary.pendingApprovalJobs;
        this.dashboardCounts.openPpms = summary.openPpms;
      },
      error: () => {
        this.dashboardCounts.openJobs = 0;
        this.dashboardCounts.pendingApprovalJobs = 0;
        this.dashboardCounts.openPpms = 0;
      }
    });
  }

  openWorkbench(): void {
    if (this.isRedirectingToWorkbench) {
      return;
    }

    this.isRedirectingToWorkbench = true;
    void this.closedownService.directToClosedown(false);
  }

  openJobs(): void {
    void this.router.navigate(['openjobs']);
  }

  openUserManagement(): void {
    void this.router.navigate(['usermanagementlist']);
  }
}